import axios from "axios";

import { VITE_BASE_URL_LEGACY } from "@/constants";

export const axiosInstanceLegacy = axios.create({
  baseURL: VITE_BASE_URL_LEGACY,
});
